module.exports = __webpack_public_path__ + "static/index/img/baikal-807.beb9ea2a.jpg";